import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TimelineLite} from "gsap";
import {ThorGameMode} from "../../gamemode/ThorGameMode";
import {ThorParsedGameData} from "../../server/data/ThorParsedGameData";
import {ThorParsedInitData} from "../../server/data/ThorParsedInitData";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";
import {ThorRandomWildsWPController} from "../../winpresentation/randomwilds/ThorRandomWildsWPController";

/**
 * Created by Jerker Nord on 2019-01-15.
 */

export class ThorExtraFreeSpinsController extends ReelStopPresentationController {

    private _playExtraFreeSpinsAwarded:boolean = false;
    private _extraFSEnabled:boolean = false;
    private _playMjolnirtime:boolean = false;
    private _currentMode:string;
    private _nextMode:string;
    private _FSLeft:number = 0;
    private _addNewFSTL:TimelineLite;
    private _isRestore:boolean;

    constructor(index:number) {
        super(index, "ThorExtraFreeSpinsController");
    }

    protected parseFeatureGameData(data:ThorParsedGameData):void {
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
        this._FSLeft = data.freespinsLeft;
        if(data.nudgeFeatureRewarded == ThorParsedGameData.NUDGE_REWARDED_EXTRA_FS_SPINS) {
            this._playExtraFreeSpinsAwarded = true;
            this._extraFSEnabled = true;
            if(data.mode == ThorGameMode.FREESPIN && data.nextMode == ThorGameMode.NUDGE_RESPIN_FS) {
                this._playMjolnirtime = true;
            }
        }
        if(this._extraFSEnabled && (data.mode == ThorGameMode.NUDGE_RESPIN_FS && data.nextMode == ThorGameMode.FREESPIN)) {
            this._extraFSEnabled = false;
            ThorGameModuleConfig.thorExtraFSIconView.disableFSIconTL();
        }
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, (event:GameEvent) => this.onRestore());
    }

    private onInitDataParsed(data:ThorParsedInitData):void {
        this._nextMode = data.nextMode;
        this._FSLeft = data.freespinsLeft;
        this._isRestore = false;

        if(data.mode == ThorGameMode.FREESPIN || data.mode == ThorGameMode.NUDGE_RESPIN_FS && (data.nextMode == ThorGameMode.NUDGE_RESPIN_FS || data.nextMode == ThorGameMode.FREESPIN)) {
            this._isRestore = true;
        }
    }

    private onRestore():void {
        if(this._isRestore == true) {
            ThorGameModuleConfig.thorExtraFSIconView.showExtraFSIconTL();
        }
    }


    private onBeforeSpinStart():void {
        if(this._nextMode == ThorGameMode.FREESPIN) {
            ThorGameModuleConfig.thorFreeSpinBoxView.updateFSNumber(this._FSLeft - 1);
        }
    }

    public abort():void {
        if(this._addNewFSTL && this._addNewFSTL.isActive()) {
            this._addNewFSTL.pause();
            this._addNewFSTL.kill();
        }
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(this._playExtraFreeSpinsAwarded == true && (data.reelId == 4 && this._currentMode == ThorGameMode.FREESPIN && this._nextMode == ThorGameMode.NUDGE_RESPIN_FS)) {
            this._playExtraFreeSpinsAwarded = false;
            if(this._addNewFSTL && this._addNewFSTL.isActive()) {
                this._addNewFSTL.pause();
                this._addNewFSTL.kill();
            }
            this._addNewFSTL = new TimelineLite({});
            if(this._playMjolnirtime == true) {
                this._playMjolnirtime = false;
                ThorGameModuleConfig.thorMjolnirtimeView.getMjolnirtimeAnimation().play();
                this._addNewFSTL.add(() => EventHandler.dispatchEvent(new GameEvent(ThorRandomWildsWPController.ICON_SELECT_ANIMATION_STARTED)));
                this._addNewFSTL.add(ThorGameModuleConfig.thorExtraFSIconView.getFSIconSelectTL((this._currentMode == ThorGameMode.NUDGE_RESPIN_FS || this._currentMode == ThorGameMode.FREESPIN)));
                this._addNewFSTL.add(() => EventHandler.dispatchEvent(new GameEvent(ThorRandomWildsWPController.ICON_SELECT_ANIMATION_COMPLETE)));
            }
        }
        this.dispatchCompleteEvent(data.reelId);
    }
}